import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from 'perfect-scrollbar';
import { NavLink } from 'react-router-dom';
import cx from 'classnames';
import { withRouter } from 'react-router-dom';


// material-ui components
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Hidden from '@material-ui/core/Hidden';
import Collapse from '@material-ui/core/Collapse';
import Person from '@material-ui/icons/Person';
import Visibility from '@material-ui/icons/Visibility';
import PowerSettingsNew from '@material-ui/icons/PowerSettingsNew';

// core components
import HeaderLinks from 'Common/Header/HeaderLinks.jsx';
import sidebarStyle from './styles.jsx';
import RoleSwitcher from 'Containers/RoleSwitcher/RoleSwitcher';
import { UserType } from 'Types';

// TODO
import LOGO from 'Layouts/Layout/images/Manuscript-logo-mini.png';
import LOGOTEXT from 'Layouts/Layout/images/Manuscript-logo-text.png';
import BACKGROUND_IMAGE from 'Layouts/Layout/images/sidebar-image.jpg';

var ps;

// We've created this component so we can have a ref to the wrapper of the links that appears in our sidebar.
// This was necessary so that we could initialize PerfectScrollbar on the links.
// There might be something with the Hidden component from material-ui, and we didn't have access to
// the links, and couldn't initialize the plugin.
class SidebarWrapper extends PureComponent {
    componentDidMount() {
        if (navigator.platform.indexOf('Win') > -1) {
            ps = new PerfectScrollbar(this.sidebarWrapper, {
                suppressScrollX: true,
                suppressScrollY: false,
            });
        }
    }

    componentWillUnmount() {
        if (navigator.platform.indexOf('Win') > -1) {
            ps.destroy();
        }
    }

    setSidebarWrapperRef = node => {
        this.sidebarWrapper = node;
    };

    render() {
        const { className, user, headerLinks, links } = this.props;

        return (
            <div className={className} ref={this.setSidebarWrapperRef}>
                {user}
                {headerLinks}
                {links}
            </div>
        );
    }
}

SidebarWrapper.propTypes = {
    className: PropTypes.string,
    user: PropTypes.object,
    headerLinks: PropTypes.any,
    links: PropTypes.any,
};

@withRouter
class Sidebar extends PureComponent {
    constructor(props) {
        super(props);

        // TODO: for collapsed routes
        this.state = {
            openUser: false,
            miniActive: true,
        };
        this.activeRoute.bind(this);
    }

    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    componentDidMount() {
        if (this.activeRoute('/profile')) {
            this.openCollapse('openUser');
        }
    }

    // verifies if routeName is the one active (in browser input)
    activeRoute(routeName) {
        return (routeName === '/'
            ? (this.props.location.pathname === routeName || !!~this.props.location.pathname.indexOf('/submissions'))
            : !!~this.props.location.pathname.indexOf(routeName));
    }

    openCollapse(collapse) {
        var st = {};
        st[collapse] = !this.state[collapse];
        this.setState(st);
    }

    openUser = event => {
        event.preventDefault();

        this.openCollapse('openUser');
    };

    setMainPanelRef = node => {
        this.mainPanel = node;
    };

    render() {
        const { classes, color, routes, bgColor, user, logout } = this.props;

        const itemText =
            classes.itemText +
            ' ' +
            cx({
                [classes.itemTextMini]: this.props.miniActive && this.state.miniActive,
            });
        const collapseItemText =
            classes.collapseItemText +
            ' ' +
            cx({
                [classes.collapseItemTextMini]: this.props.miniActive && this.state.miniActive,
            });
        const userWrapperClass =
            classes.user +
            ' ' +
            cx({
                [classes.whiteAfter]: bgColor === 'white',
            });
        const caret = classes.caret;
        const collapseItemMini = classes.collapseItemMini;

        var userBlock = (
            <div className={userWrapperClass}>
                <List className={classes.list}>
                    <ListItem className={classes.item + ' ' + classes.userItem}>
                        <a
                            href="#"
                            className={classes.itemLink + ' ' + classes.userCollapseButton + ' namaUser'}
                            onClick={this.openUser}
                        >
                            <ListItemText
                                primary={
                                    <div className="userName">
                                        {' '}
                                        <span>{user.first_name}</span> <span> {user.last_name} </span>{' '}
                                    </div>
                                }
                                secondary={
                                    <b
                                        className={
                                            caret +
                                            ' ' +
                                            classes.userCaret +
                                            ' ' +
                                            (this.state.openUser ? classes.caretActive : '')
                                        }
                                    />
                                }
                                disableTypography={true}
                                className={itemText + ' ' + classes.userItemText}
                            />
                        </a>
                        <Collapse in={this.state.openUser} unmountOnExit>
                            <List className={classes.list + ' ' + classes.collapseList}>
                                <ListItem className={classes.collapseItem}>
                                    <NavLink
                                        to="/profile"
                                        className={
                                            classes.itemLink +
                                            ' ' +
                                            classes.userCollapseLinks +
                                            ' ' +
                                            cx({
                                                [' ' + classes.collapseActive]: this.activeRoute('/profile'),
                                            })
                                        }
                                    >
                                        <span className={collapseItemMini}>
                                            <Person />
                                        </span>
                                        <ListItemText
                                            primary={this.context.intl.formatMessage({ id: 'menu.profile' })}
                                            disableTypography={true}
                                            className={collapseItemText}
                                        />
                                    </NavLink>
                                </ListItem>

                                <ListItem className={classes.collapseItem}>
                                    <span
                                        className={
                                            classes.itemLink +
                                            ' ' +
                                            classes.userCollapseLinks
                                        }
                                    >
                                        <span className={collapseItemMini}>
                                            <Visibility />
                                        </span>
                                        <span className={collapseItemText}>
                                            <RoleSwitcher />
                                        </span>
                                    </span>
                                </ListItem>

                                <ListItem className={classes.collapseItem}>
                                    <a
                                        href="#"
                                        onClick={logout}
                                        className={classes.itemLink + ' ' + classes.userCollapseLinks}
                                    >
                                        <span className={collapseItemMini}>
                                            <PowerSettingsNew />
                                        </span>
                                        <ListItemText
                                            primary={this.context.intl.formatMessage({ id: 'button.logout' })}
                                            disableTypography={true}
                                            className={collapseItemText}
                                        />
                                    </a>
                                </ListItem>
                            </List>
                        </Collapse>
                    </ListItem>
                </List>
            </div>
        );

        var links = (
            <List className={classes.list + ' listSidebar'}>
                {routes.map((prop, key) => {
                    if (prop.redirect || prop.hidden || prop.footer) {
                        return null;
                    }
                    if (prop.collapse) {
                        const navLinkClasses =
                            classes.itemLink +
                            ' ' +
                            cx({
                                [' ' + classes.collapseActive]: this.activeRoute(prop.path),
                            });
                        const itemText =
                            classes.itemText +
                            ' ' +
                            cx({
                                [classes.itemTextMini]: this.props.miniActive && this.state.miniActive,
                            });
                        const collapseItemText =
                            classes.collapseItemText +
                            ' ' +
                            cx({
                                [classes.collapseItemTextMini]: this.props.miniActive && this.state.miniActive,
                            });
                        const itemIcon = classes.itemIcon;
                        const caret = classes.caret;

                        return (
                            <ListItem key={key} className={classes.item}>
                                <a
                                    href="#"
                                    className={navLinkClasses}
                                    onClick={event => {
                                        event.preventDefault();
                                        this.openCollapse(prop.state);
                                    }}
                                >
                                    <ListItemIcon className={itemIcon}>
                                        {prop.icon ? <prop.icon /> : <img src={prop.image} />}
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={this.context.intl.formatMessage({ id: `menu.${prop.name}` })}
                                        secondary={
                                            <b
                                                className={
                                                    caret + ' ' + (this.state[prop.state] ? classes.caretActive : '')
                                                }
                                            />
                                        }
                                        disableTypography={true}
                                        className={itemText}
                                    />
                                </a>
                                <Collapse in={this.state[prop.state]} unmountOnExit>
                                    <List className={classes.list + ' ' + classes.collapseList}>
                                        {prop.views.map((prop, key) => {
                                            if (prop.redirect) {
                                                return null;
                                            }
                                            const navLinkClasses =
                                                classes.collapseItemLink +
                                                ' ' +
                                                cx({
                                                    [' ' + classes[color]]: this.activeRoute(prop.path),
                                                });
                                            const collapseItemMini = classes.collapseItemMini;

                                            return (
                                                <ListItem key={key} className={classes.collapseItem}>
                                                    <NavLink to={prop.path} className={navLinkClasses}>
                                                        <span className={collapseItemMini}>{prop.mini}</span>
                                                        <ListItemText
                                                            primary={this.context.intl.formatMessage({
                                                                id: `menu.${prop.name}`,
                                                            })}
                                                            disableTypography={true}
                                                            className={collapseItemText}
                                                        />
                                                    </NavLink>
                                                </ListItem>
                                            );
                                        })}
                                    </List>
                                </Collapse>
                            </ListItem>
                        );
                    }
                    const navLinkClasses =
                        classes.itemLink +
                        ' ' +
                        cx({
                            [' ' + classes[color]]: this.activeRoute(prop.path),
                        });
                    const itemText =
                        classes.itemText +
                        ' ' +
                        cx({
                            [classes.itemTextMini]: this.props.miniActive && this.state.miniActive,
                        });
                    const itemIcon = classes.itemIcon;

                    return (
                        <ListItem key={key} className={classes.item}>
                            <NavLink to={prop.path} className={navLinkClasses} exact>
                                <ListItemIcon className={itemIcon + ' sidebar-menu-item-icon'}>
                                    {prop.icon ? <prop.icon /> : <img src={prop.image} />}
                                </ListItemIcon>
                                <ListItemText
                                    primary={this.context.intl.formatMessage({ id: `menu.${prop.name}` })}
                                    disableTypography={true}
                                    className={itemText}
                                />
                            </NavLink>
                        </ListItem>
                    );
                })}
            </List>
        );

        var footerLinks = (
            <List className={classes.list + ' footerSidebar'}>
                {routes.map((prop, key) => {
                    if (prop.hidden || !prop.footer) {
                        return null;
                    }
                    if (prop.collapse) {
                        const navLinkClasses =
                            classes.itemLink +
                            ' ' +
                            cx({
                                [' ' + classes.collapseActive]: this.activeRoute(prop.path),
                            });
                        const itemText =
                            classes.itemText +
                            ' ' +
                            cx({
                                [classes.itemTextMini]: this.props.miniActive && this.state.miniActive,
                            });
                        const collapseItemText =
                            classes.collapseItemText +
                            ' ' +
                            cx({
                                [classes.collapseItemTextMini]: this.props.miniActive && this.state.miniActive,
                            });
                        const caret = classes.caret;

                        return (
                            <ListItem key={key} className={classes.item}>
                                <a
                                    href="#"
                                    className={navLinkClasses}
                                    onClick={event => {
                                        event.preventDefault();
                                        this.openCollapse(prop.state);
                                    }}
                                >
                                    <ListItemText
                                        primary={this.context.intl.formatMessage({ id: `menu.${prop.name}` })}
                                        secondary={
                                            <b
                                                className={
                                                    caret + ' ' + (this.state[prop.state] ? classes.caretActive : '')
                                                }
                                            />
                                        }
                                        disableTypography={true}
                                        className={itemText}
                                    />
                                </a>
                                <Collapse in={this.state[prop.state]} unmountOnExit>
                                    <List className={classes.list + ' ' + classes.collapseList}>
                                        {prop.views.map((prop, key) => {
                                            if (prop.redirect) {
                                                return null;
                                            }
                                            const navLinkClasses =
                                                classes.collapseItemLink +
                                                ' ' +
                                                cx({
                                                    [' ' + classes[color]]: this.activeRoute(prop.path),
                                                });
                                            const collapseItemMini = classes.collapseItemMini;

                                            return (
                                                <ListItem key={key} className={classes.collapseItem}>
                                                    <NavLink to={prop.path} className={navLinkClasses}>
                                                        <span className={collapseItemMini}>{prop.mini}</span>
                                                        <ListItemText
                                                            primary={this.context.intl.formatMessage({
                                                                id: `menu.${prop.name}`,
                                                            })}
                                                            disableTypography={true}
                                                            className={collapseItemText}
                                                        />
                                                    </NavLink>
                                                </ListItem>
                                            );
                                        })}
                                    </List>
                                </Collapse>
                            </ListItem>
                        );
                    }
                    const navLinkClasses =
                        classes.itemLink +
                        ' ' +
                        cx({
                            [' ' + classes[color]]: this.activeRoute(prop.path),
                        });
                    const itemText =
                        classes.itemText +
                        ' ' +
                        cx({
                            [classes.itemTextMini]: this.props.miniActive && this.state.miniActive,
                        });

                    return (
                        <ListItem key={key} className={classes.item}>
                            <NavLink to={prop.path} className={navLinkClasses} exact target='_blank'>
                                <ListItemText
                                    primary={this.context.intl.formatMessage({ id: `menu.${prop.name}` })}
                                    disableTypography={true}
                                    className={itemText}
                                />
                            </NavLink>
                        </ListItem>
                    );
                })}
            </List>
        );

        const logoNormal =
            classes.logoNormal +
            ' ' +
            cx({
                [classes.logoNormalSidebarMini]: this.props.miniActive && this.state.miniActive,
            });
        const logoMini = classes.logoMini;
        const logoClasses =
            classes.logo +
            ' ' +
            cx({
                [classes.whiteAfter]: bgColor === 'white',
            });

        var brand = (
            <div className={logoClasses}>
                <NavLink to="/" className={logoMini + ' first-logo-img'}>
                    <img src={LOGO} alt="logo" className={classes.img} />
                </NavLink>
                <NavLink to="/" className={logoNormal + ' second-logo-img'}>
                    <img src={LOGOTEXT} alt="logo" className={classes.img} />

                </NavLink>
            </div>
        );
        const drawerPaper =
            classes.drawerPaper +
            ' ' +
            cx({
                [classes.drawerPaperMini]: this.props.miniActive && this.state.miniActive,
            }) +
            (this.props.miniActive && this.state.miniActive ? ' closeSidebar' : '');
        const sidebarWrapper =
            classes.sidebarWrapper +
            ' ' +
            cx({
                [classes.drawerPaperMini]: this.props.miniActive && this.state.miniActive,
                [classes.sidebarWrapperWithPerfectScrollbar]: navigator.platform.indexOf('Win') > -1,
            });

        return (
            <div ref={this.setMainPanelRef}>
                <Hidden mdUp>
                    <Drawer
                        variant="temporary"
                        anchor="right"
                        open={this.props.open}
                        classes={{
                            paper: drawerPaper + ' ' + classes[bgColor + 'Background'],
                        }}
                        onClose={this.props.handleDrawerToggle}
                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                        }}
                    >
                        {brand}
                        <SidebarWrapper
                            className={sidebarWrapper + ' test1'}
                            user={userBlock}
                            headerLinks={<HeaderLinks logout={logout} />}
                            links={links}
                        />
                        <SidebarWrapper
                            className={sidebarWrapper + ' test2'}
                            links={footerLinks}
                        />
                        <div
                            className={classes.background}
                            style={{ backgroundImage: 'url(' + BACKGROUND_IMAGE + ')' }}
                        />
                    </Drawer>
                </Hidden>
                <Hidden smDown>
                    <Drawer
                        onMouseOver={() => this.setState({ miniActive: false })}
                        onMouseOut={() => this.setState({ miniActive: true })}
                        anchor="left"
                        variant="permanent"
                        open
                        classes={{
                            paper: drawerPaper + ' ' + classes[bgColor + 'Background'] + ' sidebar-paper-wrapper',
                        }}
                    >
                        {brand}
                        <SidebarWrapper className={sidebarWrapper + ' sidebar-content-block'} user={userBlock} links={links} />
                        <SidebarWrapper className={sidebarWrapper + ' sidebar-footer-block'} links={footerLinks} />
                        <div className={classes.background} style={{ background: '#6A446A' }} />
                    </Drawer>
                </Hidden>
            </div>
        );
    }
}

Sidebar.defaultProps = {
    bgColor: 'blue',
};

Sidebar.propTypes = {
    classes: PropTypes.object.isRequired,
    bgColor: PropTypes.oneOf(['white', 'black', 'blue']),
    color: PropTypes.oneOf(['white', 'red', 'orange', 'green', 'blue', 'purple', 'rose', 'light']),
    routes: PropTypes.arrayOf(PropTypes.object),
    open: PropTypes.bool,
    miniActive: PropTypes.bool,
    handleDrawerToggle: PropTypes.func,
    location: PropTypes.any,
    user: UserType.isRequired,
    logout: PropTypes.func.isRequired,
};

export default withStyles(sidebarStyle)(Sidebar);



// WEBPACK FOOTER //
// ./src/common/Sidebar/Sidebar.jsx